module.exports = require("userful-chronos-app-common-js/dist/message/messageTypeDefinitions/displays/UClientsMsgDefinations");